<div class="container-box shadow-none">
  <div class="d-flex gap-3 align-items-center p-3">
    <img src="/assets/images/channel-wizards/bdc/step4.webp" alt="" height="40" />
    <div>
      <h6 class="mb-0" i18n>Connect Rentals</h6>
      <div class="text-sm" i18n>
        Easily link multiple rentals under one property to ensure accurate syncing and avoid double bookings.
      </div>
    </div>
  </div>
  <div class="border-top">
    <div class="p-3">
      <app-table-search (search)="onSearch($event)" #search></app-table-search>
    </div>
    <div class="table-holder table-responsive">
      <table class="table table-default table-striped">
        <mat-table #table matSort matSortActive="roomName" matSortDirection="desc" [dataSource]="dataSource">
          <ng-container matColumnDef="roomName">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Property Name</mat-header-cell>
            <mat-cell *matCellDef="let element" class="text-truncate" [title]="element.roomName">
              <span [matTooltip]="element.roomName" matTooltipPosition="above">
                {{ element.roomName | truncate : 25 }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="propertyId">
            <mat-header-cell *matHeaderCellDef i18n> Property ID</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.propertyId }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="roomId">
            <mat-header-cell *matHeaderCellDef i18n> Room ID</mat-header-cell>
            <mat-cell *matCellDef="let element" style="word-break: break-all">
              {{ element.roomId }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="rentalName">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Linked Rental</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.rental">
                <a
                  href="javascript:void(0)"
                  [matTooltip]="element.rentalName"
                  matTooltipPosition="above"
                  (click)="onRental(element.rentalId)"
                >
                  {{ element.rentalName || '....' | truncate : 25 }}
                </a>
                <i class="fas fa-circle-check text-success ml-2"></i>
              </ng-container>
              <ng-container *ngIf="!element.rental">
                <!-- TV4-6111: the '....' placeholder row is not linkable; keep it visible but inert.
                     The span carries the tooltip because pointer-events are off on the anchor. -->
                <span [matTooltip]="element.isPlaceholderRoom ? placeholderRowTooltip : ''" matTooltipPosition="above">
                  <a
                    href="javascript:void(0)"
                    (click)="onLink(element)"
                    [class.disabled]="element.isPlaceholderRoom"
                    i18n
                    >Link Rental</a
                  >
                </span>
              </ng-container>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="rateCategory">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Rate Category</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div class="text-truncate">
                <ng-container *ngIf="element.rental">
                  <a href="javascript:void(0)" (click)="onSelectRateCategory(element)">
                    <span
                      class="far fa-exclamation-triangle text-warning mr-1"
                      *ngIf="!pushRateMap.get(element.roomId)"
                      matTooltip="Please select rate category to push rates."
                      i18n-matTooltip
                    ></span>
                    {{ pushRateMap.get(element.roomId)?.name || 'Select Category' }}
                  </a>
                </ng-container>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <app-loading-section
          *ngIf="(isEmptyTable$ | async) && !dataSource.filter && roomsStatus !== 'empty'"
        ></app-loading-section>

        <div
          class="d-flex align-items-center justify-content-between flex-column gap-2 py-4 px-3"
          *ngIf="(isEmptyTable$ | async) && !dataSource.filter && roomsStatus === 'empty'"
        >
          <img src="assets/images/empty_icons/no-result.svg" alt="" class="no-result" />
          <h5 class="no-result" i18n>No rooms found</h5>
          <p class="no-result text-center" i18n>
            We couldn't retrieve any rooms for this property. Please confirm you completed the Channel Manager
            connection step in the Booking.com extranet, then try again.
          </p>
          <button class="btn btn-secondary-info" (click)="onRetryRooms()">
            <i class="far fa-sync"></i>
            <ng-container i18n>Retry</ng-container>
          </button>
        </div>

        <div
          class="d-flex align-items-center justify-content-between flex-column gap-2 py-4 px-3"
          *ngIf="(isEmptyTable$ | async) && !!dataSource.filter"
        >
          <img src="assets/images/empty_icons/no-result.svg" alt="" class="no-result" />
          <h5 class="no-result" i18n>No Results Found</h5>
          <p class="no-result" i18n>We couldn't find any results. Change selected filters or try later</p>
        </div>

        <mat-paginator2
          #paginator
          [length]="dataSource?.data?.length"
          [class.hidden]="isEmptyTable$ | async"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 15, 20, 50, 75, 100]"
          [showFirstLastButtons]="true"
        >
        </mat-paginator2>
      </table>
    </div>
  </div>
</div>
<div class="mt-3 d-flex align-items-center gap-3">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <div class="alert alert-warning mb-0 py-2 flex-1" *ngIf="roomsStatus === 'loaded' && unlinkedCount > 0">
    <i class="far fa-exclamation-triangle mr-1"></i>
    <ng-container i18n
      >{{ unlinkedCount }} room(s) not linked to a rental — this connection will stay Pending until rooms are linked and
      both availability and rates are pushed.</ng-container
    >
  </div>
  <div
    class="alert alert-warning mb-0 py-2 flex-1"
    *ngIf="roomsStatus === 'loaded' && !unlinkedCount && missingRateCount > 0"
  >
    <i class="far fa-exclamation-triangle mr-1"></i>
    <ng-container i18n
      >{{ missingRateCount }} room(s) have no rate category — these rooms will stay Pending until you select a category
      to push their rates.</ng-container
    >
  </div>
  <div class="flex-1" *ngIf="!(roomsStatus === 'loaded' && (unlinkedCount > 0 || missingRateCount > 0))"></div>
  <div class="btn-group" dropdown placement="bottom" [dropup]="true" [isDisabled]="1 | isReadonlyRole">
    <button type="button" class="btn btn-secondary-warning dropdown-toggle" dropdownToggle>
      <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li matTooltip="Push rates for rooms shown under mapped." matTooltipPosition="left" i18n-matTooltip>
        <button type="button" (click)="onPushRates()">
          <i class="fal fa-arrow-up"></i> <ng-container i18n>Push Rates</ng-container>
        </button>
      </li>
      <li matTooltip="Push availability for rooms shown under mapped." matTooltipPosition="left" i18n-matTooltip>
        <button type="button" (click)="onPushAvailability()">
          <i class="fal fa-arrow-up"></i> <ng-container i18n>Push Availability</ng-container>
        </button>
      </li>
      <li matTooltip="Import bookings for rooms shown under mapped." matTooltipPosition="left" i18n-matTooltip>
        <button type="button" (click)="onImportBookings()">
          <i class="fal fa-arrow-down"></i> <ng-container i18n>Import Bookings</ng-container>
        </button>
      </li>
    </ul>
  </div>
  <button
    class="btn btn-secondary-info"
    [disabled]="roomsStatus === 'idle' || roomsStatus === 'polling'"
    (click)="onNext()"
  >
    <ng-container i18n>Next</ng-container>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
  </button>
</div>
